import { Injectable, signal } from '@angular/core';
import { TrgDrag, TrgDragDirective } from './TrgDrag.directive';
import { TrgDropDirective } from './TrgDrop.directive';

@Injectable({ providedIn: 'root' })
export class TrgDragDropService {
  /** Disable dragging globally. */
  readonly dragDisabled = signal(false);

  /** Drag that is currently active (dragging). */
  readonly drag = signal<TrgDragDirective>(null);

  /** Set of currently available drag drops. */
  readonly drops = new Set<TrgDropDirective>();

  /** 
   * Selects best drop for the drag event.
   * Drops are selected based on priority, and then by distance from the drag position.
   */
  getDrop(e: TrgDrag.DragEvent): TrgDropDirective {
    let drops = Array.from(this.drops)
      .filter(d => e.drag.canDropTo(d))
      .map(d => d.canDrop(e))
      .filter(d => d);

    if (!drops.length)
      return null;

    let best = drops[0];

    // Pick drop with highest priority.
    for (let i = 1; i < drops.length; ++i) {
      let d = drops[i];
      if (d.priority > best.priority) {
        best = d;
      }
    }

    // Then, and only for drops with same priority, pick by closest distance
    for (let i = 0; i < drops.length; ++i) {
      let d = drops[i];
      if (d.priority == best.priority && d.dist < best.dist) {
        best = d;
      }
    }

    return best.drop;
  }
};
